<template>
  <div class="record-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回上一层" @click="backIndex"/>
      {{shelvesName}} 货物
      <el-button v-if="isHide" type="text" @click="management(0)">管理</el-button>
      <el-button v-else type="text" @click="management(1)">取消</el-button>
    </div>

    <div class="search-result warpper">
      <ul class="result-content content">
        <li class="result-item"
          v-for="(item, index) in recordList"
          :key="index"
          @click="setItemChoose(item.id)"
        >
          <div class="leftCheckbox" v-if="!isHide">
            <el-checkbox v-model="item.isChoose" @change="setItemChoose(item.id)" />
          </div>
          <div class="rightBox">
            <div class="item-name">物品名称：{{item.goodsName}}</div>
            <div class="item-name">供应商：{{item.supplierName}}</div>
            <div class="item-name">类别：{{item.categoryName}}</div>
            <div class="item-name">规格：{{item.specification}}</div>
            <div class="item-name">物品浓度：{{item.concentrationName}}</div>
            <div class="item-name">物品颜色：{{item.colorName}}</div>
            <div class="item-name">数量：{{item.qty}}</div>
          </div>
        </li>
      </ul>
    </div>

    <div class="btnList" v-if="!isHide">
      <el-button type="primary" @click="insideBuy()">新增危险化学品使用记录</el-button>
    </div>
    <el-dialog
      :title="dialogTil"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :show-close="false"
      class="overDialog"
      :before-close="handleClose"
    >
      <div class="postBlock" v-for="(item, index) in detailList" :key="index">
        <div class="postList">
          <div class="postName">物品名称：</div>
          <div class="postValue">{{item.goodsName}}</div>
        </div>
        <div class="postList">
          <div class="postName">供应商：</div>
          <div class="postValue">{{item.supplierName}}</div>
        </div>
        <div class="postList">
          <div class="postName">类别：</div>
          <div class="postValue">{{item.categoryName}}</div>
        </div>
        <div class="postList">
          <div class="postName">规格：</div>
          <div class="postValue">{{item.specification}}</div>
        </div>
        <div class="postList">
          <div class="postName">物品浓度：</div>
          <div class="postValue">{{item.concentrationName}}</div>
        </div>
        <div class="postList">
          <div class="postName">物品颜色：</div>
          <div class="postValue">{{item.colorName}}</div>
        </div>
        <div class="postList">
          <div class="postName">原有库存：</div>
          <div class="postValue">{{item.newQty}}</div>
        </div>
        <div class="postList">
          <div class="postName">使用数量：</div>
          <div class="postValue">
            <el-input-number
              v-model="item.qty"
              :min="1"
              :max="item.newQty"
            />
          </div>
        </div>
        <div class="postList">
          <div class="postName">用途：</div>
          <div class="postValue">
            <el-select
              v-model="item.purposeId"
              placeholder="请选择用途"
              required
              @change="getPurposeName($event, index)"
            >
              <el-option
                v-for="sitem in purposeOptions"
                :key="sitem.id"
                :label="sitem.name"
                :value="sitem.id"
              />
            </el-select>
          </div>
        </div>
        <div class="postList">
          <div class="postName">使用时间：</div>
          <div class="postValue">
            <el-date-picker
              v-model="item.useDate"
              type="date"
              format="yyyy-MM-dd"
              placeholder="请选择使用时间"
              value-format="yyyy-MM-dd"
            />
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save" :loading="submitBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      popstateLock: 0,//是否监听物理返回键
      loading: false,
      pullupMsg: '加载更多',
      isShowTips: false,  // 是否提示
      shelvesName: null,  // 货位名
      recordList:[],
      isHide: true,
      visible: false,
      dialogTil: "新增危险化学品使用记录",
      detailList: [],
      medicineShelvesList: [],
      purposeOptions: [], // 用途列表
      submitBtn: false,
    };
  },
  created() {
    this.shelvesName = this.$route.query.dangerName;
    this.searchRecord();
  },
  watch: {
    popstateLock(val) {
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val) {
        this.addPopstate()
      } else {
        this.removePopstate()
      }
    }
  },
  destroyed() {
    this.removePopstate()
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    this.getPurpose();
  },
  methods: {
    addPopstate() {
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate() {
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回上一层
    backIndex() {
      this.$router.replace({ name: 'dangerShelves' })
    },
    // 管理- 判断是否显示显示勾选
    management(type) {
      this.isHide = (type === 1)
    },
    getPurpose() {
      this.$http.httpGet('/app/laPurpose/combo', {}).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.list.length == 0) {
            this.$message.info('查无记录')
          } else {
            this.purposeOptions = res.list
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getPurposeName(data, index) {
      if (data) {
        this.detailList.forEach((i, sindex) => {
          if (index === sindex) {
            let findData = this.purposeOptions.filter(s => s.id === data);
            i.purpose = findData[0].name
          }
        })
      } else {
        this.detailList.forEach((i, sindex) => {
          if (index === sindex) {
            i.purpose = null
          }
        })
      }
    },
    // 判断哪一个数据选中
    setItemChoose(id) {
      this.recordList.filter(i => {
        if (i.id === id) {
          i.isChoose = !i.isChoose
        }
      })
    },
    // 出库、入库
    insideBuy() {
      this.detailList = [];
      let getChooseList = this.recordList.filter(i => i.isChoose);
      // if (getChooseList.length > 0) {
        this.dialogTil = "新增危险化学品使用记录";
        this.visible = true;
        getChooseList.forEach(s => {
          let sPost = {
            goodsId: s.goodsId,
            goodsName: s.goodsName,
            qty: 1,
            newQty: s.qty,
            shelvesId: s.shelvesId,
            suppliersId: s.suppliersId,
            supplierName: s.supplierName,
            specification: s.specification,
            colorName: s.colorName,
            categoryName: s.categoryName,
            concentrationName: s.concentrationName,
            purpose: null,
            purposeId: null,
            useDate: moment(new Date()).format("YYYY-MM-DD")
          }
          this.detailList.push(sPost);
        })
      // } else {
      //   this.$message.error(`请选择新增危险化学品的物品`)
      // }
    },
    handleClose() {
      this.visible = false;
    },
    searchRecord() {
      let getShelvesId = this.$route.query.dangerId;
      this.$http.httpGet('/app/laShelves/listByShelvesId/' + getShelvesId, {}).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.list.length == 0) {
            this.$message.info('查无记录')
          } else {
            res.list.forEach(i => {
              i.isChoose = false;
            })
          }
          this.recordList = res.list
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 保存
    save() {
      this.submitBtn = true;
      const detailList = this.detailList.map(service => {
        const { goodsId, goodsName, qty, suppliersId, shelvesId, purpose, purposeId, specification, useDate } = service;
        return {
          goodsId,
          goodsName,
          qty,
          shelvesId,
          suppliersId,
          purpose,
          purposeId,
          specification,
          useDate: useDate ? useDate : moment(new Date()).format("YYYY-MM-DD"),
        };
      });
      this.$http.httpPost('/app/laMedicineUseRecord/save', {
        "detailList": detailList,
        "status": 0
      }).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.$message({
            message: '创建成功',
            type: 'success',
            onClose: () => {
              this.visible = false;
              this.detailList = [];
              this.submitBtn = false;
            }
          });
        } else {
          this.$message({
            message: `创建失败，错误信息:${res.msg}`,
            type: 'error'
          });
          this.submitBtn = false;
        }
      }).catch(() => {
        this.submitBtn = false;
      })
    }
  },

}
</script>

<style scoped lang="scss">
.record-search {
  margin: 0;
  padding: 50px 0 0;
  position: relative;
  width: 100%;
  .headLine {
    height: 50px;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 9;
    font-size: 16px;
    border-bottom: 1px #efefef solid;

    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
    button {
      position: absolute;
      right: 0;
      top: 0;
      width: 60px;
      height: 50px;
      font-weight: 900;
      color: #000000;
    }
  }
  .search-result {
    position: relative;
    padding: 0 0 60px;
    height: calc(100vh - 70px);
    width: 100%;
    // height: 100%;
    //overflow: hidden;

    .result-content {
      padding: 10px 20px 100px;

      .result-item {
        position: relative;
        box-sizing: border-box;
        padding: 0;
        border-radius: 0.5rem;
        margin-bottom: 15px;
        /*height: 12rem;*/
        background-color: #f2f6fc;
        color: #303133;
        font-size: 1.6rem;
        box-shadow: 0 0.3rem 0.5rem #eee;
        display: flex;
        flex-wrap: wrap;
        .leftCheckbox {
          width: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px #ececec solid;
          .el-checkbox {
            text-align: center;
          }
        }
        .rightBox {
          flex: 1;
          padding: 10px;
          .item-name {
            position: relative;
            //margin-bottom: 10px;
            text-align: left;
            line-height: 2.4;
            font-size: 1.4rem;
            color: #000;
          }
          .item-remark {
            position: relative;
            margin-bottom: 5px;
            height: 3rem;
            text-align: left;
            line-height: 3rem;
            font-size: 1.4rem;
            color: #000;
          }
        }

      }
    }
  }
  .btnList {
    position: fixed;
    bottom: 50px;
    text-align: center;
    width: 100%;
    background-color: #fff;
    z-index: 99;
    border-top: 1px #efefef solid;
    button {
      width: 98%;
      font-size: 1.3rem;
      font-weight: bold;
      margin: 10px 1% 10px;
      &:hover,
      &:active {
        color: #fff;
      }
    }
  }
}

.overDialog ::v-deep {
  .el-dialog {
    margin: 0 !important;
    width: 100%;
    .el-dialog__header {
      padding: 15px;
      border-bottom: 1px #efefef solid;
      span {
        text-align: center;
        font-size: 16px;
        display: block;
      }
    }
    .el-dialog__footer {
      padding: 15px;
      border-top: 1px #efefef solid;
      .el-button {
        width: 49%;
        &+.el-button {
          margin: 0 0 0 2%;
        }
      }
    }
    .el-dialog__body {
      height: calc(100vh - 55px - 71px - 30px);
      padding: 15px;
      overflow-x: hidden;
      overflow-y: auto;
      .postBlock {
        margin: 0 0 15px;
        position: relative;
        border-bottom: 1px #efefef solid;
        .postList {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          margin: 0 0 10px;


          .postName {
            width: 90px;
            font-size: 14px;
            letter-spacing: 1px;
            text-align: right;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            line-height: 1.8;
          }
          .postValue {
            flex: 1;
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 1.8;
            .el-input-number {
              width: 100%;
            }
            .el-select {
              width: 100%;
            }
            .el-date-editor {
              width: 100%;
            }
          }
        }
      }
      .holdPart {
        position: relative;
        .postList {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          .postName {
            width: 90px;
            font-size: 14px;
            letter-spacing: 1px;
            text-align: right;
            line-height: 1.8;
          }
          .postValue {
            flex: 1;
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 1.8;
            .el-input-number {
              width: 100%;
            }
            .el-select {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #666;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.el-select-dropdown__item {
  font-size: 14px !important;
  line-height: 34px;
  padding: 0 20px;
}
</style>
